import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { BeaconPositionEvent } from "../api/models";
import { CsvColumn, useDownloadCsv } from "../util";

interface DownloadPositionsProps {
  style?: React.CSSProperties;
  beaconId: string;
  positions: BeaconPositionEvent[];
  from: Date;
  to: Date;
}

const columns: CsvColumn<BeaconPositionEvent>[] = [
  {
    title: "Serial",
    value: (_p, _c, i) => i,
  },
  {
    title: "MeasuredAt",
    value: (p, c) => p.position.ts?.toLocaleString(c),
  },
  {
    title: "Latitude",
    value: (p, c) => p.position.lat?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Longitude",
    value: (p, c) => p.position.lon?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Altitude",
    value: (p, c) => p.position.alt?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Horizontal Accuracy",
    value: (p, c) =>
      p.position.acc.h?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Vertical Accuracy",
    value: (p, c) =>
      p.position.acc.v?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Timestamp Accuracy",
    value: (p, c) =>
      p.position.acc.t?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "HDOP",
    value: (p, c) =>
      p.position.dop.h?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "PDOP",
    value: (p, c) =>
      p.position.dop.p?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "VDOP",
    value: (p, c) =>
      p.position.dop.v?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Satellites Used",
    value: (p, c) =>
      p.position.sats?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
  {
    title: "Carrier Phase Range Solution",
    value: (p, c) =>
      p.position.cprs?.toLocaleString(c, { maximumSignificantDigits: 20 }),
  },
];

export function DownloadPositions(props: DownloadPositionsProps) {
  const { t } = useTranslation();

  const { positions, from, to, beaconId } = props;
  const download = useDownloadCsv(
    beaconId,
    positions,
    columns,
    `BeaconPositions_${beaconId}_${from.toISOString()}_${to.toISOString()}.csv`
  );

  return (
    <div style={props.style}>
      <Button type="dashed" onClick={download}>
        {t("save-as-csv")}
      </Button>
    </div>
  );
}
